import React from 'react';

import Subheader from 'material-ui/Subheader';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import ActionProject from 'material-ui/svg-icons/action/build';

const h2Icon = {
  marginLeft: 24,
  marginRight: 24,
};

let page = (props) => (
  <div>
    <h2><ActionProject style={h2Icon} />Projects</h2>
    <List>
      <ListItem
        primaryText="EAST - Using Evolutionary Algorithms to Understand and Secure Web/Enterprise Systems"
        secondaryText={<span>Kristiania University College<br/><a href="https://www.kristiania.no/en/research/research-projects/kuc/east-using-evolutionary-algorithms-to-understand-and-secure-webenterprise-systems/" target="_blank">http://www.kristiania.no/en/research/</a><br />2020-2025</span>}
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <ListItem
        primaryText="EDOS - Effective Digitalization of the Public Sector"
        secondaryText={<span>Simula Metropolitan Center for Digital Engineering<br/><a href="https://edos.simulamet.no" target="_blank">edos.simulamet.no</a><br />2020-ongoing</span>}
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <ListItem
        primaryText="CERSE - A Catalog for Empirical Research in Software Engineering"
        secondaryText={<span>BTH - Blekinge Tekniska Högskola<br />2014-2017</span>}
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <ListItem
        primaryText="SESRA - App to Support Systematic Reviews in Software Engineering"
        secondaryText={<span>CNPq - Conselho Nacional de Desenvolvimento Científico e Tecnológico and UNIVALI - Universidade do Vale do Itajaí<br />2012-2013</span>}
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <ListItem
        primaryText="Web Portal for Environmental Education"
        secondaryText={<span>FAPESC - Fundação de Amparo à Pesquisa e Inovação do Estado de Santa Catarina and UNIVALI - Universidade do Vale do Itajaí<br />Project Coordinator — 2013-2014</span>}
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <ListItem
        primaryText="SE-RPG - Software Engineering Role-playing Game"
        secondaryText={<span>UNIVALI - Universidade do Vale do Itajaí<br />2005-2006</span>}
        disabled="true"
        insetChildren="true"
      />
    </List>
  </div>
);

export default page;



// WEBPACK FOOTER //
// ./src/components/Home/Projects.js